"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDisplayName = exports.parseNamePartsFromFullName = exports.jfd = exports.masterKeyFieldName = exports.bookingNumberFieldName = void 0;
const jfd_1 = require("@le2/jfd");
const option_lists_1 = require("./option-lists");
exports.bookingNumberFieldName = 'BookingNumber';
exports.masterKeyFieldName = 'UCN';
exports.jfd = {
    bookingNumberFieldName: exports.bookingNumberFieldName,
    masterKeyFieldName: exports.masterKeyFieldName,
    convertToUpperCase: true,
    images: {
        modalities: {
            [jfd_1.Modality.Face]: {},
            [jfd_1.Modality.SMT]: {}
        }
    },
    fields: Object.assign({ TypeOfTransaction: {
            minLength: 3,
            maxLength: 3,
            options: [['CAR', 'Criminal Ten-Print Submission']],
            EBTS: {
                mnemonic: 'T1_TOT',
                index: '1.004',
                dataType: 'A'
            }
        }, Date: {
            label: 'Transaction Date',
            type: 'date',
            readOnly: true,
            desc: 'The date the transaction was initiated. This field cannot be altered by the user.',
            EBTS: {
                mnemonic: 'T1_DAT',
                index: '1.005',
                dataType: 'N',
                format: 'YYYYMMDD'
            }
        }, TransactionControlNumber: {
            label: 'Transaction Control Number',
            minLength: 10,
            maxLength: 40,
            desc: 'This mandatory field shall contain the Transaction Control Number as assigned by the originating agency. A unique control number should be assigned to each transaction. For any transaction that requires a response, the respondent shall refer to this number in communicating with the originating agency.',
            EBTS: {
                mnemonic: 'T1_TCN',
                index: '1.009',
                dataType: 'ANS',
                specialChars: 'PRINT'
            }
        }, FBINumber: {
            label: 'FBI Number',
            //required: false,
            minLength: 9,
            maxLength: 9,
            desc: "This field contains the subject's FBI number (if known). A valid FBI number shall be no more than nine alphanumeric characters.No special characters allowed.",
            EBTS: {
                mnemonic: 'T2_FBI',
                index: '2.014',
                dataType: 'AN'
            }
        }, StateIDNumber: {
            label: 'State ID Number',
            //required: false,
            minLength: 3,
            maxLength: 10,
            regex: /^AZ[0-9]{1,8}$/,
            desc: 'The State ID number if known to the user. This field may contain between 3 and 10 characters and must begin with AZ. The remainder of the field may contain Alpha/Numeric characters.',
            EBTS: {
                mnemonic: 'T2_SID',
                index: '2.015',
                dataType: 'ANS',
                specialChars: '-'
            }
        }, SocialSecurityNumber: {
            label: 'Social Security Number',
            //required: false,
            minLength: 9,
            maxLength: 9,
            regex: /^(?!123456789)(?!000000000)(?!999999999)\d{9}$/,
            desc: 'The Social Security field allows exactly 9 Numeric characters with NO hyphens.',
            EBTS: {
                mnemonic: 'T2_SOC',
                index: '2.016',
                dataType: 'N'
            }
        }, MiscellaneousIDNumbers: {
            label: 'Miscellaneous Identification Number',
            //required: false,
            minLength: 4,
            maxLength: 15,
            maxOccurrences: 4,
            desc: "If there are any miscellaneous identification numbers, they shall be entered in this field. The format of the data shall be a two-letter identifying code, followed by a hyphen (-), followed by a 1-12 character identification number. The following table lists the acceptable two-letter identifying agency codes. For 'AF' or 'AS' all characters in the identification number must be numeric. Interspersed blanks are invalid. Types of numbers not listed in the following table (such as driver's license) shall not be entered.Only U.S.passport numbers shall be entered; foreign numbers shall be ignored. As many as four miscellaneous identification numbers may be included in this field.",
            EBTS: {
                mnemonic: 'T2_MNU',
                index: '2.017',
                dataType: 'ANS',
                specialChars: '-'
            }
        }, 
        //
        // Needed by the JFD framework abstraction
        //
        DisplayFullName: {
            label: 'Full Name',
            desc: "The Subject's name to be displayed in the application.",
            readOnly: true
        }, 
        //
        // TODO: It seems like the app framework still refers to SubjectName, instead of referring to the DisplayName.
        // Eventually this shoul be delete
        //
        SubjectName: {
            subFields: {
                fields: {
                    Last: { readOnly: true },
                    Middle: { readOnly: true },
                    First: { readOnly: true },
                    Suffix: { readOnly: true }
                }
            }
        }, FullName: {
            label: 'Full Name',
            minLength: 3,
            maxLength: 50,
            desc: "This field contains the name of the subject. The surname should be entered first separated by a comma, followed by the given name(s), which are separated by a space. This field should contain an alpha string of no more than 30 characters. Comma, hyphen, and blanks are allowed as special characters. Special values of NAM, to be entered in cases where the subject's name is not known, are: 'Amnesia Victim' - 'UNKNOWN AMNESIA,XX'; 'Unknown Deceased' - 'UNKNOWN DECEASED, XX'; 'Name Not Available(Other)' - 'DOE, JOHN' or 'DOE, JANE'",
            EBTS: {
                mnemonic: 'T2_NAM',
                index: '2.018',
                dataType: 'AS',
                specialChars: '-, '
            }
        }, Aliases: {
            label: 'Aliases',
            //required: false,
            minLength: 3,
            maxLength: 30,
            maxOccurrences: 99,
            desc: 'This field contains alias names of the subject. This field indicates the number of aliases present. Up to ten aliases may be provided. This field should contain a string of up to 30 alpha numeric characters. The surname should be entered first, separated by a comma, followed by the given name(s), which are separated by a space. Hyphens, ampersands, commas and blanks as well as all letters are allowed.',
            EBTS: {
                mnemonic: 'T2_AKA',
                index: '2.019',
                dataType: 'ANS',
                specialChars: '-, '
            }
        }, PlaceOfBirth: {
            label: 'Place of Birth',
            minLength: 2,
            maxLength: 2,
            desc: "Subject's place of birth. If not known select UNKNOWN PLACE OF BIRTH.",
            options: option_lists_1.OPTIONS_PLACEOFBIRTH,
            EBTS: {
                mnemonic: 'T2_POB',
                index: '2.020',
                dataType: 'A'
            }
        }, DateOfBirth: {
            label: 'Date of Birth',
            maxDate: jfd_1.getMaxDateOfBirth(18),
            type: 'date',
            desc: 'DOB allows for any Subject who is 8 years old or older. A date of birth less than 8 years will be rejected. Users may type over the date listed or use the drop down arrow to display and choose from the calendar function.',
            EBTS: {
                mnemonic: 'T2_DOB',
                index: '2.022',
                dataType: 'N',
                format: 'YYYYMMDD'
            }
        }, CurrentAge: {
            label: 'Age',
            desc: "The Subject's current age to be displayed in the application.",
            readOnly: true
        }, BookingAge: {
            label: 'Age at Booking',
            desc: "The Subject's booking age to be displayed in the application.",
            readOnly: true
        }, Sex: {
            label: 'Sex',
            minLength: 1,
            maxLength: 1,
            options: option_lists_1.OPTIONS_SEX,
            EBTS: {
                mnemonic: 'T2_SEX',
                index: '2.024',
                dataType: 'A'
            }
        }, Race: {
            label: 'Race',
            minLength: 1,
            maxLength: 1,
            desc: "Users may choose from Asian, Black, Caucasian/Latino, Native American and Unknown to define a Subject's race.",
            options: option_lists_1.OPTIONS_RACE,
            EBTS: {
                mnemonic: 'T2_RAC',
                index: '2.025',
                dataType: 'A'
            }
        }, Height: {
            label: 'Height',
            minLength: 3,
            maxLength: 3,
            regex: /^[4-7]([0][0-9]|[1][0-1])$|^000$/,
            desc: 'Height is defined with a three character Numeric. The first digit provides the feet measurement while the second two digits define the inches. For example, if the subject is 5 feet 8 inches the numeric input would be 508. Allowed values are 000, 400-711.',
            EBTS: {
                mnemonic: 'T2_HGT',
                index: '2.027',
                dataType: 'AN'
            }
        }, Weight: {
            label: 'Weight',
            minLength: 3,
            maxLength: 3,
            regex: /^(0[5-9][0-9])$|^([1-4][0-9]{2})$|^000$/,
            desc: 'The three digit Numeric depicting Weight (in pounds) may be 000, or from 051 to 499.',
            EBTS: {
                mnemonic: 'T2_WGT',
                index: '2.029',
                dataType: 'N'
            }
        }, EyeColor: {
            label: 'Eye Color',
            minLength: 3,
            maxLength: 3,
            desc: "Subject's eye color is selected from the drop down list provided.",
            options: option_lists_1.OPTIONS_EYECOLOR,
            EBTS: {
                mnemonic: 'T2_EYE',
                index: '2.031',
                dataType: 'A'
            }
        }, HairColor: {
            label: 'Hair Color',
            minLength: 3,
            maxLength: 3,
            desc: "Subject's hair color is selected from the drop down list provided.",
            options: option_lists_1.OPTIONS_HAIRCOLOR,
            EBTS: {
                mnemonic: 'T2_HAI',
                index: '2.032',
                dataType: 'A'
            }
        }, ResidenceOfPersonFingerprinted: {
            label: 'Residence of Person Fingerprinted',
            //required: false,
            minLength: 1,
            maxLength: 120,
            desc: "The subject's residential address may be entered in this field as free text, including printable special characters and formatting characters(CR, LF, TAB).The RES returned in a response is the same as the one submitted.",
            EBTS: {
                mnemonic: 'T2_RES',
                index: '2.041',
                dataType: 'ANS',
                specialChars: 'PRINTCTRL'
            }
        }, DateOfArrest: {
            label: 'Date of Arrest',
            type: 'date',
            desc: 'The Date of Arrest is automatically set to the Transaction date. If the date requires changing, users may type over existing date displayed or select from the drop down calendar.',
            EBTS: {
                mnemonic: 'T2_DOA',
                index: '2.045',
                dataType: 'N',
                format: 'YYYYMMDD'
            }
        }, BookingAgency: {
            label: 'Booking Agency',
            minLength: 1,
            maxLength: 9,
            desc: "The valid ORI (Originating Agency Identification) for the agency submitting this Subject's fingerprints.",
            options: option_lists_1.OPTIONS_ORICODES,
            EBTS: {
                mnemonic: 'T2_CRI',
                index: '2.073',
                dataType: 'AN'
            }
        }, MugshotPhysicalCharacteristicsSet: {
            label: 'Mugshot Physical Characteristics Set',
            //required: false,
            EBTS: {
                mnemonic: 'T2_MUG',
                index: '2.399:',
                dataType: 'AS'
            },
            subFields: {
                fields: {
                    Glasses: {
                        label: 'Glasses',
                        minLength: 2,
                        maxLength: 3,
                        options: option_lists_1.OPTIONS_GLASSES,
                        EBTS: {
                            mnemonic: 'T2_MUG_GLS',
                            index: '2.399..1',
                            dataType: 'A'
                        }
                    },
                    HairLength: {
                        label: 'Hair Length',
                        minLength: 3,
                        maxLength: 3,
                        options: option_lists_1.OPTIONS_HAIRLENGTH,
                        EBTS: {
                            mnemonic: 'T2_MUG_HAL',
                            index: '2.399..2',
                            dataType: 'A'
                        }
                    },
                    HairStyle: {
                        label: 'Hair Style',
                        minLength: 3,
                        maxLength: 3,
                        options: option_lists_1.OPTIONS_HAIRSTYLE,
                        EBTS: {
                            mnemonic: 'T2_MUG_HAS',
                            index: '2.399..3',
                            dataType: 'A'
                        }
                    },
                    Complexion: {
                        label: 'Complexion',
                        minLength: 3,
                        maxLength: 10,
                        options: option_lists_1.OPTIONS_COMPLEXION,
                        EBTS: {
                            mnemonic: 'T2_MUG_CPX',
                            index: '2.399..4',
                            dataType: 'AS'
                        }
                    },
                    Beard: {
                        label: 'Beard',
                        minLength: 3,
                        maxLength: 3,
                        options: option_lists_1.OPTIONS_BEARD,
                        EBTS: {
                            mnemonic: 'T2_MUG_BRD',
                            index: '2.399..5',
                            dataType: 'A'
                        }
                    },
                    Mustache: {
                        label: 'Mustache',
                        minLength: 3,
                        maxLength: 3,
                        options: option_lists_1.OPTIONS_MUSTACHE,
                        EBTS: {
                            mnemonic: 'T2_MUG_MST',
                            index: '2.399..6',
                            dataType: 'A'
                        }
                    },
                    Sideburns: {
                        label: 'Sideburns',
                        minLength: 2,
                        maxLength: 3,
                        options: option_lists_1.OPTIONS_SIDEBURNS,
                        EBTS: {
                            mnemonic: 'T2_MUG_BRN',
                            index: '2.399..7',
                            dataType: 'A'
                        }
                    },
                    FacialHair: {
                        label: 'Facial Hair',
                        minLength: 3,
                        maxLength: 4,
                        options: option_lists_1.OPTIONS_FACIALHAIR,
                        EBTS: {
                            mnemonic: 'T2_MUG_FCH',
                            index: '2.399..8',
                            dataType: 'A'
                        }
                    },
                    Build: {
                        label: 'Build',
                        minLength: 3,
                        maxLength: 3,
                        options: option_lists_1.OPTIONS_BUILD,
                        EBTS: {
                            mnemonic: 'T2_MUG_BLD',
                            index: '2.399..9',
                            dataType: 'A'
                        }
                    }
                }
            }
        }, LocalAFISNumber: {
            label: 'Local AFIS Number',
            //required: false,
            minLength: 8,
            maxLength: 8,
            EBTS: {
                mnemonic: 'T2_LAN',
                index: '2.779',
                dataType: 'N'
            }
        }, LegacyJailIdentifier: {
            label: 'Legacy Jail Identifier',
            //required: false,
            minLength: 7,
            maxLength: 10,
            desc: 'This field contains the identifying computer control number from a jail facility.',
            EBTS: {
                mnemonic: 'T2_JID',
                index: '2.2005',
                dataType: 'AN'
            }
        }, [exports.bookingNumberFieldName]: {
            label: 'Booking Number',
            //required: false,
            minLength: 9,
            maxLength: 9,
            desc: 'This field will be populated only at those livescans interfaced with the Subject in Process (SIP) system and refers to a specific booking into the King County Jail. The livescan operator shall have the ability to modify the field after a SIP download or to manually enter data.',
            EBTS: {
                mnemonic: 'T2_BA',
                index: '2.2006',
                dataType: 'N'
            }
        }, [exports.masterKeyFieldName]: {
            label: 'UCN',
            //required: false,
            EBTS: {
                mnemonic: 'T2_JUCN',
                index: '2.2105'
            }
        }, 
        //
        // Note: according to an older comment these were added to comply with the
        // web app at some point, with the lineup filters in particular. However,
        // there are many bookings in KC-STAGE that do have that field, but it's
        // empty in all cases (at least those that I checked) so, we leave them
        // here to avoid errors when loading those bookings.
        //
        HairLength: {}, SkinTone: {} }, jfd_1.type10Fields),
    //
    // These rules get called only once per application run
    //
    onInit: [
        function (ctx) {
            ctx.setValue('TypeOfTransaction', 'CAR');
        }
    ],
    //
    // These rules get called every time the Booking Form is recreated
    //
    onCreate: [
        function (ctx) {
            ctx.setValue('Date', new Date().toISOString().slice(0, 10)); // YYYY-MM-DD
        }
    ],
    //
    // These rules get called only when an EBTS file is getting created. Note that in many cases we are dynamically
    // creating new fields based on existing ones, and therefore these new fields will not be stored in the database
    // but will only appear in EBTS files.
    //
    onGenerateEBTSFile: [],
    //
    // These rules get called only when an EBTS file is being imported to our system.
    //
    onImport: [
        // validate TOT
        function (ctx) {
            const tot = ctx.getValue('TypeOfTransaction');
            if (!tot || tot !== 'CAR') {
                ctx.importErrors.push('The 1.004 TOT field is not CAR');
            }
        },
        // LegacyJailIdentifier fix, see LENEXTGEN-588
        function (ctx) {
            const ucn = ctx.getValue('UCN');
            const legacyJailIdentifier = ctx.getValue('LegacyJailIdentifier');
            if (!ucn) {
                if (legacyJailIdentifier) {
                    ctx.setValue('UCN', legacyJailIdentifier);
                }
                else {
                    ctx.importErrors.push('Neither a 2.2005 JID nor a 2.2105 JUCN field were provided');
                }
            }
        },
        // NOTE there are some cases of imperfect parsing for a target of [Last, First Middle Suffix]. In these cases extra parts are simply dropped
        //  1) FullName with multi-word first or middle names (which is usually unsupported)
        //    eg 'ESTRADA, ISAURO DE LUNA JR' to 'ESTRADA,ISAURO DE LUNA'
        //    and 'KABA, ABU BAKR SIDIK IBN ABDEL AZIZ' to 'KABA,ABU BAKR SIDIK'
        //  ...see test cases
        // Fillout SubjectName field if necessary
        function (ctx) {
            try {
                // if subjectName does not exist (getValue fails), parse FullName
                const subjectName = ctx.getValue('SubjectName');
            }
            catch (_a) {
                const fullName = ctx.getValue('FullName');
                const nameFields = parseNamePartsFromFullName(fullName);
                if (nameFields[0])
                    ctx.setValue('SubjectName.Last', nameFields[0]);
                if (nameFields[1])
                    ctx.setValue('SubjectName.First', nameFields[1]);
                if (nameFields[2])
                    ctx.setValue('SubjectName.Middle', nameFields[2]);
                if (nameFields[3])
                    ctx.setValue('SubjectName.Suffix', nameFields[3]);
            }
        },
        // Compute BookingAge
        function (ctx) {
            if (!ctx.getValue('DateOfBirth')) {
                ctx.setValue('BookingAge', '');
                return;
            }
            if (!ctx.getValue('DateOfArrest')) {
                ctx.setValue('BookingAge', '');
            }
            const age = jfd_1.calculateAge(new Date(ctx.getValue('DateOfBirth')), new Date(ctx.getValue('DateOfArrest')));
            if (age > 0) {
                ctx.setValue('BookingAge', age.toString());
            }
            else {
                ctx.setValue('BookingAge', '');
            }
        }
    ],
    //
    // These rules get called continuously during the lifetime of the form, this is the truly 'reactive' part of JFD
    //
    rules: [
        // Compute DisplayFullName
        // NOTE:
        // Not sure why this is required for this rule and not CurrentAge rule
        // Field will not be updated without final call to getValue()
        function (ctx) {
            ctx.setValue('DisplayFullName', formatDisplayName(ctx.getValue('FullName')));
            ctx.getValue('DisplayFullName');
        },
        // Compute CurrentAge
        function (ctx) {
            if (!ctx.getValue('DateOfBirth')) {
                ctx.setValue('CurrentAge', '');
                return;
            }
            const age = jfd_1.calculateAge(new Date(ctx.getValue('DateOfBirth')));
            ctx.setValue('CurrentAge', age.toString());
        }
    ]
};
function parseNamePartsFromFullName(fullName) {
    const nullCharDelim = '\0';
    // in the regex below
    //  $3 and $5 are discarded as they include the optional space preceding the Middle and Suffix, respectively
    //  $7 is the remainder of the name that is lost
    //                                             $1         $2   $3$4     $5$6     $7
    //                                             Last...    First  Middle   Suffix
    const parseNameToFourPartsRegex = new RegExp(/^([^,]+),\s*(\S+)( (\S+))?( (\S+))?(.*)?$/);
    const newName = fullName
        .trim()
        .replace(parseNameToFourPartsRegex, `$1${nullCharDelim}$2${nullCharDelim}$4${nullCharDelim}$6`);
    const nameFields = newName.split(nullCharDelim, 4);
    return nameFields;
}
exports.parseNamePartsFromFullName = parseNamePartsFromFullName;
function formatDisplayName(fullName) {
    return fullName.replace(/,(?! )/, ', ').trim();
}
exports.formatDisplayName = formatDisplayName;
//# sourceMappingURL=jfd-kcso.js.map